import React from "react"
import { withRouter } from "react-router"
import { useMutation } from "@apollo/react-hooks"
import ShoppingCartItem from "./ShoppingCartItem"
import { UPDATE_SHOPPING_CART, SHOPPING_CART } from "../gql"

const ShoppingCartItems = props => {
  const [updateShoppingCart] = useMutation(UPDATE_SHOPPING_CART, {
    refetchQueries: [{ query: SHOPPING_CART }]
  })

  /**
   * Update shoppingcart
   */
  const updateToCart = async () => {
    updateShoppingCart({
      variables: {
        orderId: props.shoppingCartId,
        orderDetailInputs: props.orderDetails.map(orderDetail => {
          return {
            product: orderDetail.product.id,
            quantity: orderDetail.quantity,
            unitPrice: orderDetail.unitPrice
          }
        })
      }
    })
  }

  /**
   * Count subtotal
   * @param {*} orderDetails
   */
  const subtotal = orderDetails => {
    const _subtotal = orderDetails?.map(el => el.sum).reduce((a, b) => a + b)
    return _subtotal
      ? `NT$ ${_subtotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
      : "選購商品有需議價項目"
  }

  /**
   * Update shopping quantity
   * @param {*} key
   * @param {*} value
   */
  const updateCartQuantity = (key, value) => {
    const details = props.orderDetails
    details[key] = {
      ...props.orderDetails[key],
      quantity: value
    }
    props.writeData("orderDetails", details)
  }

  return (
    <>
      <div className="shopcart-detail">
        <div className="shopcart-columns-block">
          <div className="column-name image" />
          <div className="column-name">品名</div>
          <div className="column-name">價格</div>
          <div className="column-name">數量</div>
          <div className="column-name">小計</div>
          {!props.justPreview && <div className="column-name">刪除</div>}
        </div>

        <div className="shopcart-products-block">
          {props.orderDetails?.map((orderDetail, key) => {
            return (
              <ShoppingCartItem
                key={key}
                index={key}
                orderDetail={orderDetail}
                updateCartQuantity={(key, value) => {
                  updateCartQuantity(key, value)
                }}
                updateToCart={() => updateToCart()}
                readOnly={props.readOnly}
                justPreview={props.justPreview}
              />
            )
          })}
        </div>
      </div>
      <div className="text-left mb-3">{subtotal(props.orderDetails)}</div>
    </>
  )
}

export default withRouter(ShoppingCartItems)
